<template>
  <div class="card-feature-review__container">
    <div class="card-feature-review__content">
      <div class="card-feature-review__heading">
        <img class="card-feature-review__image" :src="imageUrl">
        <div>
          <CustomText weight="bold">
            {{ author }}
          </CustomText>
          <CustomText size="small">
            {{ media }}
          </CustomText>
        </div>
      </div>
      <CustomText class="card-feature-review__body">
        {{ body }}
      </CustomText>
    </div>
  </div>
</template>

<script>
import CustomText from '@/components/common/CustomText/CustomText'

export default {
  components: {
    CustomText
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    author: {
      type: String,
      required: true
    },
    media: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.card-feature-review {
  &__container {
    padding: $gap * 1.5;
    background-color: #2C1A48;
    border-radius: 8px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: $gap;
  }

  &__heading {
    display: flex;
    flex-direction: row;
    gap: $gap;
  }

  &__image {
    width: 40px;
    height: 40px;
  }
}
</style>
